<template>
  <div class="info-wrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.info-wrapper >*:not(:last-child) {
  margin-bottom: measure(half);
}
.info-wrapper >*:last-child {
  padding-bottom: measure(half);
}
</style>
